"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinoNodeRuntimeTransport = exports.default = void 0;
var _pinoAbstractTransport = _interopRequireDefault(require("pino-abstract-transport"));
var _canRunLogHandler = require("./canRunLogHandler");
var _filterPinoMessage = require("./filterPinoMessage");
var _getEnabledLogHandlersForTransport = require("./getEnabledLogHandlersForTransport");
const pinoNodeRuntimeTransport = options => {
  const enabledLogHandlers = (0, _getEnabledLogHandlersForTransport.getEnabledLogHandlersForTransport)(options);

  // Let's just override transform for the sake of typescript
  return (0, _pinoAbstractTransport.default)(async transform => {
    try {
      for await (const obj of transform) {
        const pinoMessage = obj;

        // Run all enabled log handlers
        for (const [transportType, logHandler] of enabledLogHandlers) {
          const shouldSkip = !(0, _canRunLogHandler.canRunLogHandler)({
            loggerConfiguration: options.loggerConfiguration,
            pinoMessage,
            transportType
          });
          if (shouldSkip) {
            continue;
          }
          logHandler((0, _filterPinoMessage.filterPinoMessage)(pinoMessage));
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console -- we cannot use
      console.error('Failed to execute log handler in defined Node.js transport', {
        error
      });
      throw error;
    }
  });
};
exports.pinoNodeRuntimeTransport = pinoNodeRuntimeTransport;
var _default = exports.default = pinoNodeRuntimeTransport;
//# sourceMappingURL=pinoNodeRuntimeTransport.js.map